import React from "react";
import { renderMonthlyRateWithPrice } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import type {
    CarModelLabelType,
    CommonFinanceInfoType,
    PriceType,
} from "../../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../../redux/store";
import { getBnbMonthlyRateFormat, shouldNotRenderAemPrice } from "../../../../utils/settings/bnbFinanceSettingUtils";
import CashPrice from "./CashPrice";
import CashPriceIsrael from "./CashPriceIsrael";
import MonthlyPrice from "./MonthlyPrice";

import * as Styles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/DisplayPrice";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import { getCashPriceDisclaimerLabel } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { isIsrael } from "../../../../../../../common-deprecated/settings/utils/commonSettingUtils";

type DisplayPricePropsType = {
    price: PriceType;
    financeInfo?: CommonFinanceInfoType;
    cashPriceDisclaimer?: CarModelLabelType[]; // Used as a VAT disclaimer at the total price, currently only used for Israel.
};

const DisplayPrice = ({ price, financeInfo, cashPriceDisclaimer }: DisplayPricePropsType): JSX.Element | null => {
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    const modelCode = useBnbSelector((state) => state.car?.model?.internalCode || "");

    const financeOption = useBnbSelector((state) => state.utils.financeOption);

    if (
        // Hide when the price should not be rendered
        shouldNotRenderAemPrice(
            commonSettings,
            bnbSettings,
            price,
            financeOption,
            NavStep.Model,
            modelCode,
            financeOption === "monthly",
        )
    ) {
        return null;
    }

    // show cash price together with monthly rate, but do not yet show cash price when monthly rate is loading
    const renderMonthlyWithCash = renderMonthlyRateWithPrice(commonSettings);

    return (
        <Styles.Wrapper>
            {financeOption === "cash" && (
                <>
                    {isIsrael(commonSettings.culture.name) ? (
                        <CashPriceIsrael
                            price={price}
                            cashPriceDisclaimer={
                                cashPriceDisclaimer && getCashPriceDisclaimerLabel(cashPriceDisclaimer)
                            }
                        />
                    ) : (
                        <CashPrice price={price} />
                    )}
                </>
            )}
            {financeOption === "monthly" && financeInfo && (
                <MonthlyPrice
                    price={price}
                    priceFormat={getBnbMonthlyRateFormat(commonSettings, modelCode)}
                    financeInfo={financeInfo}
                />
            )}
            {financeOption === "monthly" && renderMonthlyWithCash && (
                <>
                    {isIsrael(commonSettings.culture.name) ? (
                        <CashPriceIsrael
                            price={price}
                            cashPriceDisclaimer={
                                cashPriceDisclaimer && getCashPriceDisclaimerLabel(cashPriceDisclaimer)
                            }
                        />
                    ) : (
                        <CashPrice price={price} />
                    )}
                </>
            )}
        </Styles.Wrapper>
    );
};

export default DisplayPrice;
